import {callAPI} from '@/store/utils'; // eslint-ignore-line
import {sendErrorToBackend, userDetails} from '@/utils/errorHandler.js';

const FYGR_COMPANY = 'FYGR_COMPANY';
const FYGR_ACCESS_TOKEN = 'FYGR_ACCESS_TOKEN';
const FYGR_PRETENDED_USER = 'FYGR_PRETENDED_USER';
const COOKIE_NAME = '_aw_master_id';
let controller = new AbortController();
let {signal} = controller;
const urlBase = `${import.meta.env.VITE_APP_API}/v2`;

const updateSignal = () => {
  controller.abort();
  controller = new AbortController();
  /* eslint-disable */
  signal = controller.signal;
  /* eslint-enable */
  return signal;
};

export default {
  namespaced: true,
  state: {
    gotBanks: false,
    banks: null,
    rules: [],
    currencyList: [],
    dashboardSelectedAccounts: null,
  },
  getters: {
    bankNumber(state) {
      return state.banks ? state.banks.length : 0;
    },
    currencyListSorted(state) {
      return state.currencyList.map((itm) => {
        const res = {
          name: itm.iso,
          id: itm.id.toString(),
        };
        return res;
      });
    },
    currencyListDropDown(state) {
      return state.currencyList.map((itm) => [itm.id, itm.iso]);
    },
    pinnedBanks(state) {
      return state.banks?.map((b) => ({
        ...b,
        accounts: b.accounts.filter((a) => a.pinned),
      }));
    },
    pinnedAccountsList(state) {
      return state.banks
        ?.reduce((acc, el) => [...acc, ...el.accounts], [])
        .filter((account) => account.pinned)
        .map((a) => a.id);
    },
    allAccountsList(state) {
      return state.banks?.reduce(
        (acc, el) => [
          ...acc,
          ...el.accounts.map((account) => ({
            ...account,
            type: el.type,
            bank_name: el.name,
            bank_custom_name: el.custom_name,
          })),
        ],
        [],
      );
    },
    accountsListWithIbans(state) {
      return state.banks
        ? state.banks
            ?.reduce(
              (acc, bank) => [
                ...acc,
                ...bank.accounts.map((account) => ({
                  id: account.id,
                  balance: account.balance,
                  currency: account.currency,
                  iban: account.iban,
                  pinned: account.pinned,
                  bic: account.bic || null,
                  type: bank.type,
                  accountName: account.custom_name || account.name,
                  bankName: bank.custom_name || bank.name,
                })),
              ],
              [],
            )
            .filter((account) => !!account.iban)
        : [];
    },
  },
  mutations: {
    setDashboardSelectedAccounts(state, accs) {
      state.dashboardSelectedAccounts = accs;
    },
    setBanks(state, banks) {
      state.banks = banks;
      state.gotBanks = true;
    },
    unauthBanks(state) {
      state.gotBanks = false;
      state.banks = null;
      state.rules = [];
    },
    editRule(state, rule) {
      const index = state.rules.findIndex((r) => r.id === rule.id);
      state.rules[index] = rule;
    },
    setCurrencyList(state, list) {
      state.currencyList = list.sort((a, b) => {
        if (a.iso > b.iso) {
          return 1;
        }
        if (a.iso < b.iso) {
          return -1;
        }
        return 0;
      });
    },
    setRules(state, rules) {
      state.rules = rules;
    },
    addRule(state, rule) {
      state.rules.push(rule);
    },
    deleteRule(state, id) {
      const index = state.rules.findIndex((r) => r.id === id);
      state.rules.splice(index, 1);
    },
    addBank(state, params) {
      if (!state.banks) {
        state.banks = [
          {
            id: params.bankId,
            last_update: params.lastUpdate,
            name: params.name,
            custom_name: null,
            accounts: [],
            state: {
              status: 'working',
              provider_code: 'active',
              action_required_fygr: false,
              fygr_description: 'Connexion opérationnelle.',
              fygr_short_message: 'Connexion active',
            },
          },
        ];
      } else {
        state.banks.push({
          id: params.bankId,
          last_update: params.lastUpdate,
          name: params.name,
          custom_name: null,
          accounts: [],
          state: {
            status: 'working',
            provider_code: 'active',
            action_required_fygr: false,
            fygr_description: 'Connexion opérationnelle.',
            fygr_short_message: 'Connexion active',
          },
        });
      }
    },
    addAccount(state, params) {
      const banks = [...state.banks];
      const idx = banks.findIndex((b) => b.id === params.bankId);
      banks[idx].accounts.push({
        id: params.accountId,
        balance: 0,
        currency: 'EUR',
        name: params.name,
        custom_name: null,
      });
      state.banks = [...banks];
    },
    pinAccounts(state, params) {
      const banks = [...state.banks];
      const bidx = banks.findIndex((b) => b.id === params.bank_id);
      params.account_ids.map((id) => {
        const aidx = banks[bidx].accounts.findIndex((a) => a.id === id);
        banks[bidx].accounts.splice(aidx, 1, {
          ...banks[bidx].accounts[aidx],
          pinned: params.pinned,
        });
        return null;
      });
      state.banks = [...banks];
    },
    updateAccountName(state, params) {
      const banks = [...state.banks];
      const bidx = banks.findIndex((b) => b.id === params.connection_id);
      const aidx = banks[bidx].accounts.findIndex(
        (a) => a.id === params.account_id,
      );
      banks[bidx].accounts[aidx].custom_name = params.name;
      state.banks = [...banks];
    },
    deleteAccount(state, params) {
      const banks = [...state.banks];
      const bidx = banks.findIndex((b) => b.id === params.bankId);
      const aidx = banks[bidx].accounts.findIndex(
        (a) => a.id === params.accountId,
      );
      banks[bidx].accounts.splice(aidx, 1);
      state.banks = [...banks];
    },
    updateConnectionName(state, params) {
      const banks = [...state.banks];
      const bidx = banks.findIndex((b) => b.id === params.connection_id);
      banks[bidx].custom_name = params.name;
      state.banks = [...banks];
    },
  },
  actions: {
    async actionDeleteAccount({commit}, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      commit('deleteAccount', params);
      const res = await callAPI('POST', 'deleteAccount', {
        ...params,
        companyId,
      });
      return res;
    },
    async actionRenameAccount({commit}, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      commit('updateAccountName', params);
      const res = await callAPI('POST', 'updateAccountName', {
        ...params,
        companyId,
      });
      return res;
    },
    async actionRenameConnection({commit}, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      commit('updateConnectionName', params);
      const res = await callAPI('POST', 'updateConnectionName', {
        ...params,
        companyId,
      });
      return res;
    },
    async actionPinAccounts({commit}, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      commit('pinAccounts', params);
      const res = await callAPI('POST', 'pinAccounts', {...params, companyId});
      return res;
    },
    async actionAddManualConnection({commit}, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      commit('addBank', params);
      const res = await callAPI('POST', 'addManualConnection', {
        ...params,
        companyId,
      });
      return res;
    },
    async actionUnauthBanks({commit}) {
      commit('unauthBanks');
    },
    async actionAddManualAccount({commit}, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      commit('addAccount', params);
      const res = await callAPI('POST', 'addManualAccount', {
        ...params,
        companyId,
      });
      return res.result;
    },
    async actionGetRules({commit}, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'listSubCategoryRules', {
        ...params,
        companyId,
      });
      if (res.result) {
        commit('setRules', res.result.rules_list);
      }
      return res.result;
    },
    async actionGetAffectedTransactions(_, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'getAffectedTransactions', {
        companyId,
        ...params,
      });
      return res;
    },
    async actionGetAffectedInvoices(_, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'getInvoicesAffectedByRule', {
        companyId,
        ...params,
      });
      return res;
    },
    async actionGetSuggestions() {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'getSuggestionsList', {companyId});
      return res;
    },
    async actionSwitchSuggestions(_, {suggestionsEnabled, withList}) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'switchSuggestions', {
        companyId,
        suggestionsEnabled,
        withList,
      });
      return res;
    },
    async actionDeleteSuggestion(_, suggestionId) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'deleteSuggestion', {
        companyId,
        suggestionId,
      });
      return res;
    },
    async actionSetRules({commit}, {rules, trackId}) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      commit('setRules', rules);
      const res = await callAPI(
        'POST',
        'setSubCategoryRules',
        {rules, companyId, trackId},
        false,
        60,
        0,
      );
      return res;
    },
    async actionAddSingleRule({commit}, data) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      commit('setRules', data.rules);
      const res = await callAPI('PUT', 'createNewSubCategoryRule', {
        rule: data.rule,
        companyId,
      });
      return res;
    },
    async actionCheckRuleConflicts({commit}, rule) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'checkRulesConflicts', {
        rule,
        companyId,
      });
      return res.result;
    },
    async actionReindexTransactions() {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      await callAPI('POST', 'reindexTransactions', {companyId});
    },
    async actionDeleteRule({commit}, id) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      commit('deleteRule', id);
      await callAPI('POST', 'removeSubCategoryRule', {id, companyId});
    },
    async actionEditRule({commit, dispatch, state}, rule) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      commit('editRule', rule);
      const updatedRule = {...rule};
      delete updatedRule.priority;
      delete updatedRule.category;
      await callAPI('POST', 'editSubCategoryRule', {...updatedRule, companyId});
      dispatch('actionSetRulesOrder', state.rules);
    },
    async actionSetRulesOrder({commit}, rules) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const newRules = rules.map((r, i) => ({...r, priority: i + 1}));
      const toApi = newRules.map((r) => r.id);
      commit('setRules', newRules);
      await callAPI('POST', 'setSubCategoryRulePriorities', {
        rules: toApi,
        companyId,
      });
    },
    async actionGetBankAccount(_, code) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'getBankAccount', {code, companyId});
      return res.result;
    },
    async actionGetBankAccountFromProvider(_, params) {
      const res = await callAPI('POST', 'getBankAccounts', params);
      if (res && !res.error) {
        return res.result;
      }
    },
    async actionLoadTransactions({dispatch}) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      dispatch('app/actionSetReloading', true, {root: true});
      const res = await callAPI(
        'POST',
        'loadTransactions',
        {companyId},
        false,
        0,
      );
      await new Promise((resolve) => {
        setTimeout(() => resolve(), 30000);
      });
      await dispatch('actionGetBanksAndAccountsList');
      dispatch('app/actionSetReloading', false, {root: true});
      if (res && !res.error) {
        return res.result;
      }
    },
    async actionGetBanksAndAccountsList({commit}, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'getBanksAndAccountsList', {
        ...request,
        companyId,
      });
      commit('setBanks', res?.result?.banks || []);
    },
    async actionGetBanksForMC(_, request) {
      const res = await callAPI('POST', 'getBanksAndAccountsList', request);
      return res.result.banks;
    },
    async actionDeleteConnection({dispatch}, data) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI(
        'POST',
        'deleteConnection',
        typeof data === 'object' ? data : {bank_id: data, companyId},
      );
      await dispatch('actionGetBanksAndAccountsList');
      return res.result;
    },
    async cleanCategoryAdjustments(_, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'cleanCategoryAdjustments', {
        ...params,
        companyId,
      });
      return res;
    },
    async actionGetModifyUrl(_, id) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'getModifyUrl', {
        bank_id: id,
        companyId,
      });
      window.location = res.result.url;
      return res.result;
    },
    async actionUnsyncBankConnection() {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'unsyncBankConnection', {
        companyId,
        aggregatorName: 'bridge',
      });
      return res;
    },
    async actionGetTransaction(_, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'getTransaction', {
        ...request,
        companyId,
      });
      return res;
    },
    // FIXME:TT-3331
    async actionGetTransactions(_, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI(
        'POST',
        'getTransactionList',
        {
          ...request,
          companyId,
        },
        false,
        0,
      );
      return res.result;
    },
    async actionExportDashboardXLSX(_, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI(
        'POST',
        'exportDashboardXLSX',
        {...request, companyId},
        false,
        60,
        0,
      );
      return res;
    },
    async exportDashboardConsolidationTableXLSX(_, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI(
        'POST',
        'exportDashboardConsolidationTableXLSX',
        {...request, companyId},
        false,
        60,
        0,
      );
      return res;
    },
    async actionSetBankingTransactionsCategory(_, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI(
        'POST',
        'setBankingTransactionsCategory',
        {...request, companyId},
        false,
        30,
        3,
      );
      return res;
    },
    async actionUpdateBankingTransactions(_, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI(
        'PUT',
        'updateTransaction',
        {...request, companyId},
        false,
        30,
        3,
      );
      return res;
    },
    async actionDownloadTransactions(_, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'downloadTransactions', {
        ...request,
        companyId,
      });
      return res;
    },
    async actionDownloadInvoices(_, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'downloadInvoices', {
        ...request,
        companyId,
      });
      return res;
    },
    async actionSetTransactionStatus(_, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'setTransactionStatus', {
        ...request,
        companyId,
      });
      return res;
    },
    async actionGetDashboardChartData(_, params) {
      const companyId = params.companyId || localStorage.getItem(FYGR_COMPANY);
      const newSignal = params.companyId ? null : updateSignal();
      const res = await callAPI(
        'POST',
        'getDashboardChartData',
        {...params, companyId},
        false,
        120,
        0,
        false,
        newSignal,
      );
      return res.result;
    },
    async actionUploadAttachments(_, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'uploadAttachments', {
        ...params,
        companyId,
      });
      return res;
    },
    async actionGetPresignedUrlForAttachment(_, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'getPresignedUrlForAttachment', {
        ...params,
        companyId,
      });
      return res.result;
    },
    async actionSaveTransactionComment(_, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'setTransactionComment', {
        ...params,
        companyId,
      });
      return res;
    },
    async actionSetTransactionValidated(_, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'setTransactionValidated', {
        ...params,
        companyId,
      });
      return res;
    },
    async actionDeleteAttachment(_, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'deleteAttachment', {
        ...params,
        companyId,
      });
      return res;
    },
    async actionGetDashboardTableData(_, params) {
      const companyId = params.companyId || localStorage.getItem(FYGR_COMPANY);
      const newSignal = params.companyId ? null : updateSignal();
      const res = await callAPI(
        'POST',
        'getDashboardChartData',
        {...params, companyId},
        false,
        120,
        0,
        false,
        newSignal,
      );
      return res.result;
    },
    async actionGetOldestTransactionDate() {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'getOldestTransactionDate', {
        companyId,
      });
      return res;
    },
    async actionGetDashboardTransactions(_, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'getDashboardTransactions', {
        ...params,
        companyId,
      });
      return res.result;
    },
    async actionAddManualAdjustment(_, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'addManualAdjustment', {
        ...params,
        companyId,
      });
      return res;
    },
    async actionEditManualAdjustment(_, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'editManualAdjustment', {
        ...params,
        companyId,
      });
      return res;
    },
    async actionDeleteManualAdjustment(_, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'deleteManualAdjustment', {
        ...params,
        companyId,
      });
      return res;
    },
    async actionGetManualAdjustmentComments(_, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'getMAComments', {
        ...params,
        companyId,
      });
      if (!res?.result || !res?.result?.comments) {
        return [];
      }
      return res.result.comments;
    },
    async actionUpdateManualAdjustmentComment(_, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'updateMAComment', {
        ...params,
        companyId,
      });
      return res;
    },
    async actionDeleteMAComment(_, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'deleteMAComment', {
        ...params,
        companyId,
      });
      return res;
    },
    async actionGetManualAdjustments({commit}, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      return await callAPI('POST', 'getManualAdjustments', {
        ...request,
        companyId,
      });
    },
    async actionGetCurrencyList({commit}) {
      const res = await callAPI('POST', 'getCurrencyList', {});
      commit('setCurrencyList', res.result.list);
      return res.result.list;
    },
    async actionGetCurrencyHistory({_}) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      let pretendedUser = null;
      try {
        pretendedUser = JSON.parse(localStorage.getItem(FYGR_PRETENDED_USER));
      } catch {} // eslint-disable-line
      let token = null;
      if (!pretendedUser) {
        token = localStorage.getItem(FYGR_ACCESS_TOKEN);
      } else {
        token = pretendedUser.token;
      }
      return await fetch(`${urlBase}/company/${companyId}/currenciesHistory`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type':
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
      });
    },
    async actionGetOngoingTransfers({commit}, accountId) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const params = {
        account_id: accountId,
        status: 'pending',
      };
      const queryString = new URLSearchParams(params).toString();
      const res = await callAPI(
        'GET',
        `company/${companyId}/transferOrders?${queryString}`,
      );
      return res?.result;
    },
    async actionDeleteOngoingTransfers({commit}, transferId) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      return await callAPI(
        'DELETE',
        `company/${companyId}/transferOrder/${transferId}`,
      );
    },
    async actionArchiveConnection({commit}, connectionId) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      return await callAPI('POST', `company/${companyId}/archiveConnection`, {
        connectionId,
      });
    },
    async actionSetMasterCookie({_}) {
      if (
        ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname)
      ) {
        return;
      }

      function getCookie(name) {
        return (
          document.cookie
            .split('; ')
            .find((c) => c.startsWith(name + '='))
            ?.split('=')[1] || null
        );
      }

      const hasCookie = !!getCookie(COOKIE_NAME);
      let id = localStorage.getItem(COOKIE_NAME);

      if (!id) {
        id = window.utils.genId();
        localStorage.setItem(
          COOKIE_NAME,
          hasCookie ? getCookie(COOKIE_NAME) : id,
        );
      }

      if (!hasCookie) {
        try {
          document.cookie = `_aw_master_id=${id}; path=/; domain=.fygr.io; SameSite=Lax`;

          await fetch(`${urlBase}/set-mc`, {
            method: 'POST',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
          });
        } catch (err) {
          let details = userDetails();
          details.err = err;
          details.errName = 'Master cookie set error';
          sendErrorToBackend(details);
        }
      }
    },
    async actionGetBankTransferUrl({commit}, request) {
      const company_id = localStorage.getItem(FYGR_COMPANY);
      return await callAPI('POST', 'transfer', {
        ...request,
        company_id,
      });
    },
    async actionGetExternalTransfer({commit}, externalPaymentId) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      return await callAPI(
        'GET',
        `company/${companyId}/transferAttempt/${externalPaymentId}`,
      );
    },
    async actionUpdateAccountBic({commit}, params) {
      const company_id = localStorage.getItem(FYGR_COMPANY);
      return await callAPI(
        'PATCH',
        `company/${company_id}/account/${params.accountId}`,
        {
          bic: params.bic,
        },
      );
    },
  },
};
